const NAMESPACE = "validator";

const KEYS = {
    inValidDateFormatMsg: "inValidDateFormatMsg",
    inValidEmailFormatMsg: "inValidEmailFormatMsg",
    requiredMsg: "requiredMsg",
    requiredTrueMsg: "requiredTrueMsg",
    invalidMultiEmailOrTagsMsg: "invalidMultiEmailOrTagsMsg",
    invalidSingleTagsOnlyMsg: "invalidSingleTagsOnlyMsg",
    invalidSingleEmailOrTagsMsg: "invalidSingleEmailOrTagsMsg",
    invalidIntegerMsg: "invalidIntegerMsg",
    invalidPositiveIntegerMsg: "invalidPositiveIntegerMsg",
    invalidNonNegativeIntegerMsg: "invalidNonNegativeIntegerMsg",
    invalidPositiveNumberMsg: "invalidPositiveNumberMsg",
    invalidNonNegativeNumberMsg: "invalidNonNegativeNumberMsg",
    invalidPhoneMsg: "invalidPhoneMsg",
    invalidMoneyMsg: "invalidMoneyMsg",
    invalidDecimalMsg: "invalidDecimalMsg",
    invalidPasswordMsg: "invalidPasswordMsg",
    invalidCrossCheckMsg: "invalidCrossCheckMsg",
    invalidTotpMsg: "invalidTotpMsg",
    invalidMultiEmailMsg: "invalidMultiEmailMsg"
};

const MESSAGES = {
    [KEYS.inValidDateFormatMsg]: {
        value: "Please specify a valid date in {dateFormat} format.",
        comment: "Error message specifying correct date format."
    },
    [KEYS.inValidEmailFormatMsg]: {
        value: "Please enter a valid email in the following format: name{'@'}example.com",
        comment: "Error message specifying correct email format."
    },
    [KEYS.requiredMsg]: {
        value: "This field is required.",
        comment: "Error message indicating a required field is missing"
    },
    [KEYS.requiredTrueMsg]: {
        value: "This field is required.",
        comment: "Error message indicating a true false field must be true"
    },
    [KEYS.invalidMultiEmailOrTagsMsg]: {
        value: "Please specify a valid email address or data field (e.g. {'{data:XXXXX}'} or {'{AssigneeEmail}'} or {'{ProjectOwnerEmail}'}). Separate multiple addresses with commas or semicolons.",
        comment: "Error message specifying correct email address format for multiple email addresses or tags"
    },
    [KEYS.invalidSingleTagsOnlyMsg]: {
        value: "Please specify a valid data field (e.g. {'{data:XXXXX}'} or {'{AssigneeEmail}'} or {'{ProjectOwnerEmail}'}).",
        comment:
            "Error message for specifying correct format of a single email address that must be a template tag of a data field or built in field"
    },
    [KEYS.invalidSingleEmailOrTagsMsg]: {
        value: "Please specify a valid email address or data field (e.g. {'{data:XXXXX}'} or {'{AssigneeEmail}'} or {'{ProjectOwnerEmail}'}).",
        comment: "Error message for specifying the correct format for a single email address or template tag address"
    },
    [KEYS.invalidIntegerMsg]: {
        value: "Please enter a valid whole number.",
        comment: "Error message indicating the input is not a valid whole number"
    },
    [KEYS.invalidPositiveIntegerMsg]: {
        value: "Please enter a whole number greater than 0.",
        comment: "Error message indicating the input is not a whole number greater than 0"
    },
    [KEYS.invalidNonNegativeIntegerMsg]: {
        value: "Please enter a whole number greater than or equal to 0.",
        comment: "Error message indicating the input is not a whole number greater than or equal to 0"
    },
    [KEYS.invalidPositiveNumberMsg]: {
        value: "Please enter a number greater than 0.",
        comment: "Error message indicating the input is not a number greater than 0"
    },
    [KEYS.invalidNonNegativeNumberMsg]: {
        value: "Please enter a number greater than or equal to 0.",
        comment: "Error message indicating the input is not a number greater than or equal to 0"
    },
    [KEYS.invalidPhoneMsg]: {
        value: "Please enter a valid phone number in the format: (###) ###-####",
        comment: "Error message indicating the input is not a valid phone number in the specified format"
    },
    [KEYS.invalidMoneyMsg]: {
        value: "Please enter a valid currency in the format: '1356.97'",
        comment: "Error message indicating the input is not a valid currency in the specified format"
    },
    [KEYS.invalidDecimalMsg]: {
        value: "Please enter a valid decimal number.",
        comment: "Error message indicating the input is not a valid decimal number"
    },
    [KEYS.invalidPasswordMsg]: {
        value: "Password must be at least 8 characters long, must include at least one uppercase letter, one lowercase letter, and one number, and must not start or end with spaces.",
        comment: "Error message indicating the password does not meet the specified requirements"
    },
    [KEYS.invalidCrossCheckMsg]: {
        value: "Code should be exactly 6 characters and only include letters, numbers, $ and #",
        comment: "Error message indicating the code does not meet the specified requirements"
    },
    [KEYS.invalidTotpMsg]: {
        value: "Code should be a 6-digit number.",
        comment: "Error message indicating the code is not a 6-digit number"
    },
    [KEYS.invalidMultiEmailMsg]: {
        value: "Please enter one or more valid email addresses separated by commas or semicolons.",
        comment:
            "Error message indicating the input is not one or more valid email addresses separated by commas or semicolons"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
